import React from "react";

const Video = ({ setIsOpen }) => {
    return(<div class="absolute top-0 h-screen w-screen bg-black overflow-hidden">
    <div class="flex items-center justify-center h-full w-full">
        <video controls class="w-full h-full overflow-hidden">
         <source src={require("../assets/sunnsett_sipper_review.mp4")} type="video/mp4" />
        </video>
        </div>
        <div class="absolute top-12 right-12">
            <div class="bg-white h-12 w-12 flex items-center justify-center rounded-full cursor-pointer" title="close video" onClick={()=> setIsOpen(false)}>
                <h1 class="primary">X</h1>
            </div>
        </div>
    </div>)
}

export default Video;